module.exports = __webpack_public_path__ + "img/style3_756cbc771.png";